module.exports = __webpack_public_path__ + "static/media/icons8-contact-details.012fad0c.svg";